module.exports = __webpack_public_path__ + "img/symbol_12.26402fc2.png";